import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';
import { notification } from 'antd';
import { Icon } from 'dlweb-components';

angular.module('webTools').directive('wtProjectEditor', ['$timeout', 'Auth', '$rootScope', 'Project', 'ModalWindow', 'MenuBuilder', 'Utility', '$ngRedux', 'File',
    function ($timeout, Auth, $rootScope, Project, ModalWindow, MenuBuilder, Utility, $ngRedux, File) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            projectInfo: '=',
            dirty: '='
        },
        templateUrl: '/partials/project-editor.html',
        controller: ['$scope', '$element', '$attrs', '$routeParams', 'Columns', function($scope, $element, $attrs, $routeParams, Columns) {

            $scope.addFileButton = [{ key: "project-addfile", action: "addProjectFile", data: {}, icon: <Icon type="file-plus" />, label: "Add File" }];
            $scope.versions = $scope.projectInfo.versionHistory.reverse();
            $scope.kendo = $scope.kendo || {};
            $scope.selectedItems = [];
            $scope.menuOptions = $scope.addFileButton;
            $scope.workingVersion = $scope.versions[0];
            $scope.versionDetails = {};
            $scope.gridName = 'projectEditorGrid';
            $scope.showDelete = false;
            $scope.versionNotes = '';
            
            $scope.store = $ngRedux;

            $scope.setVersionInfo = function (projectId, versionId) {
                Project.getVersionInfo(projectId, versionId).then(function (response) {

                    $scope.versionDetails = response.data.versionDetails;
                    $scope.versionDetails.versionNotes = response.data.versionNotes;

                    $scope.$watch('projectForm.$dirty', function (newValue, previousValue) {
                        if (newValue === true) {
                            $element.find('.ok-button').removeClass('ok-button-disabled');
                            $scope.dirty = true;
                        }
                    })
                })
            }

            $scope.setVersionInfo($scope.projectInfo.projectId, $scope.workingVersion);

            $scope.versionClick = function (version) {
                if (version !== $scope.workingVersion) {
                    $scope.workingVersion = version;
                    $element.find('.ok-button').addClass('ok-button-disabled');
                    $scope.$broadcast('reloadGrid');
                    $scope.setVersionInfo($scope.projectInfo.projectId, $scope.workingVersion);
                }
            }

          $scope.newVersion = function () {
            Project.createNewVersion($scope.projectInfo.projectId).then(function (res) {
                  $scope.projectInfo.versionHistory = _.map(res.data, 'VersionID').reverse();
                  $scope.versions = $scope.projectInfo.versionHistory;
                  $scope.workingVersion = $scope.projectInfo.versionHistory[0];
                  $rootScope.$broadcast('reloadGrid');
                })
            }

            $scope.deleteVersion = function (e, version) {

                e.stopPropagation();

                var message = "Are you sure you want to delete version " + version + "?";

                ModalWindow.openConfirmation(message, function () { 
                    Project.deleteVersion($scope.projectInfo.projectId, version).then(function (res) {
                        $scope.projectInfo.versionHistory = _.map(res.data, 'VersionID').reverse();
                        if (version === $scope.workingVersion) {
                            $scope.versionClick($scope.projectInfo.versionHistory[0]);
                        }
                    })
                });
            }

            $rootScope.addFileEditor = function (fileId) {
              Project.addVersionFile($scope.projectInfo.projectId, $scope.workingVersion, [fileId]).then(function (res) {
                if (res.data.Message === '') {
                  if ($scope.workingVersion === $scope.projectInfo.versionHistory[0]) {
                    $rootScope.$broadcast('reloadGrid');
                  } else {
                    $scope.$broadcast('reloadGrid');
                  }
                }
                else {
                  alert(res.data.Message)
                }
              });
            };

            $scope.saveChanges = function () {;
                Project.saveProject($scope.projectInfo.projectId, $scope.workingVersion, $scope.projectInfo.name, $scope.projectInfo.description, $scope.versionDetails.versionNotes).then(function(data) {
                    $scope.projectForm.$setPristine();
                    $scope.dirty = false;
                    $rootScope.$broadcast('reloadGrid');
                    $element.find('.ok-button').addClass('ok-button-disabled');
                    notification.success({ message: `Project saved.` });
                })
            }

          $scope.$on('addProjectFile', function (e, data) {
            window.launchLegacyDialog('project-addfile-editor');
          })

          $scope.$on('selectedItemsUpdated', function (e, selectedItems) {

            $scope.selectedItems = selectedItems;

            if (selectedItems.length > 0) {
              $scope.menuOptions = MenuBuilder.getProjectFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
            }
            else {
              $scope.menuOptions = $scope.addFileButton;
            }
          });

            $scope.$on('launchProjectFileDialog', function (e, data) {

              const fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Version', 'Minor', 'Name', 'Type']));

              const packageCallback = () => { $scope.$broadcast('reloadGrid'); }

              const { key } = data;

              switch (key) {
                case 'download':
                  File.download(fileIds, 'download')
                  break;
                case 'checkout':
                case 'project-checkout':
                  File.download(fileIds, 'checkout', packageCallback)
                  break;
                case 'undocheckout':
                case 'project-undocheckout':
                  File.undoCheckout(fileIds, false, packageCallback);
                  break;
                case 'quickapprovalworkflow':
                  const modalOptions = {
                    title: 'Quick Approval Workflow',
                    maskClosable: false,
                    footer: null
                  }
                  $ngRedux.dispatch(actions.showModal('QUICK_APPROVAL_WORKFLOW', modalOptions, { selectedItems: $scope.selectedItems }));
                  break;
                case 'preview':

                  let previewObject = {
                    id: $scope.selectedItems[0].ID,
                    version: $scope.selectedItems[0].Version,
                    minor: $scope.selectedItems[0].Minor
                  }

                  $scope.$emit('loadObjectPreview', previewObject);
                  break;
                case 'project-removefile':
                  ModalWindow.openConfirmation('Remove selected file(s) from project?', function () {
                    Project.removeVersionFile($scope.projectInfo.projectId, $scope.workingVersion, _.map($scope.selectedItems, 'ID')).then(function () {
                      if ($scope.workingVersion === $scope.projectInfo.versionHistory[0]) {
                        $rootScope.$broadcast('reloadGrid');
                      } else {
                        $scope.$broadcast('reloadGrid');
                      }
                    });
                  });

                  break;
                default:

                  if (key === 'project-checkin' && $scope.versions[0] !== $scope.workingVersion) {
                    key = 'project-checkin-previous'
                  }

                  window.launchLegacyDialog(key, $scope.selectedItems, $scope.projectInfo.projectId, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
                  break;
              }
            });

            $scope.$on('refreshProjectView', () => {
                $scope.$broadcast('reloadGrid');
            })

            $scope.projectEditorOptions = {
                loadOnInit: true,
                mainGrid: false,
                responsive: false,
                allowRowSelect: true,
                allowMultiselect: false,
                allowColumnState: false,
                allowSelectFolders: false,
                enableContextMenu: true,
                columnMenu: false,
                sortable: true,
                resizable: false,
                reorderable: true,
                scrollable: true,
                pageable: {
                    info: true,
                    refresh: false
                }
            };

            const state = $ngRedux.getState();
            const endpoint = state.app.endpoint;

            $scope.projectEditorData = {
                transport: {
                    read: {
                        url: `${endpoint ? endpoint : ''}/api/Projects/GetFiles`,
                        contentType: 'application/json',
                        dataType: 'json'
                    },
                    parameterMap: function (data, operation) {

                        if (data.sort && data.sort.length > 0) {
                            const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };
                            
                            if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
                        }

                        data = $.extend({ folderID: $scope.projectInfo.projectId, version: $scope.workingVersion }, data);

                        return data;
                    }
                },
                schema: {
                    data: function (response) {
                        return response.Data;
                    },
                    total: 'TotalRows'
                },
                serverPaging: true,
                serverSorting: true,
                pageSize: 50,
                page: 1
            };

            $scope.getColumns = function () {
              return Columns.getProjectDocumentColums($scope.projectInfo.projectId);
	        };

            // Work around a bug in the kendo grid that adds extra height to the initial grid render
	        $scope.$on('gridLoaded', function () {
	            $timeout(function () {
	                $element.find('#projectEditorGrid .k-grid .k-grid-content').height('350px');
	            })
	        })
        }],
        link: function (scope, element, attributes) {

        }
    };
}]);